/* src/app/features/modalidade_garantia/modalidade-garantia.component.scss */
#pointer :hover {
  cursor: pointer;
}
.head-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/*# sourceMappingURL=modalidade-garantia.component.css.map */
